import "./App.css";
import "./Style.scss";
import StartScreen from "./Pages/StartScreen";
import Instruction from "./Pages/Instruction";
import CategorySelection from "./Pages/CategorySelection";
import CounterView from "./Pages/CounterView";
import QuizQuestion from "./Pages/QuizQuestion";
import ExplanationPage from "./Pages/ExplanationPage";
import IndividualResult from "./Pages/IndividualResult";
import EnterDataResult from "./Pages/EnterDataResult";
import Leaderbord from "./Pages/Leaderbord";
import { HashRouter as Router, Routes, Route } from "react-router";
import { createContext, useContext, useState, useEffect } from "react";
import prefetch_file from "./Utils/prefetchVideo";
export const DataContext = createContext(null);

function App() {
  const [onlineData, setOnlineData] = useState(null);
  const [responses, setResponses] = useState(null);
  const [users, setUsers] = useState(null);
  const [userData, setUserData] = useState(null);
  useEffect(() => {
    if (responses && responses.length > 0) {
      responses.forEach((question) => {
        if (
          !question["Knowledge Piece Image"].endsWith(".png") &&
          !question["Knowledge Piece Image"].endsWith(".jpg")
        ) {
          prefetch_file(
            question["Knowledge Piece Image"],
            (url) => {
              question["video_blob_Knowledge"] = url;
            },
            () => {},
            () => {}
          );
        }
        if (
          !question["Question Image"].endsWith(".png") &&
          !question["Question Image"].endsWith(".jpg")
        ) {
          prefetch_file(
            question["Question Image"],
            (url) => {
              question["video_blob"] = url;
            },
            () => {},
            () => {}
          );
        }
      });
    }
  }, [responses]);
  return (
    <>
      <DataContext.Provider value={onlineData}>
        <Router>
          <Routes>
            <Route tran path="/" element={<StartScreen />} />
            <Route
              path="/Instruction"
              element={<Instruction setOnlineData={setOnlineData} />}
            />
            <Route
              path="/CategorySelection"
              element={
                <CategorySelection
                  responses={responses}
                  setResponses={setResponses}
                />
              }
            />
            <Route
              path="/CounterView"
              element={<CounterView responses={responses} />}
            />
            <Route
              path="/QuizQuestion/:id"
              element={
                <QuizQuestion
                  responses={responses}
                  setResponses={setResponses}
                />
              }
            />
            <Route
              path="/Explanation/:id"
              element={
                <ExplanationPage
                  responses={responses}
                  setResponses={setResponses}
                />
              }
            />
            <Route
              path="/IndividualResult"
              element={
                <IndividualResult
                  responses={responses}
                  users={users}
                  setUsers={setUsers}
                />
              }
            />
            <Route
              path="/EnterDataResult"
              element={
                <EnterDataResult
                  responses={responses}
                  users={users}
                  setUsers={setUsers}
                  setUserData={setUserData}
                />
              }
            />
            <Route
              path="/Leaderbord"
              element={
                <Leaderbord
                  responses={responses}
                  users={users}
                  setUsers={setUsers}
                  userData={userData}
                />
              }
            />
          </Routes>
        </Router>
      </DataContext.Provider>
      {responses &&
        responses.map((question) => (
          <>
            {
              question["Knowledge Piece Image"].endsWith(".png") ||
              question["Knowledge Piece Image"].endsWith(".jpg") ? (
                <img
                  style={{ display: "none" }}
                  src={question["Knowledge Piece Image"]}
                  alt="Ultrasound Image"
                />
              ) : (
                <div style={{ display: "none" }}></div>
              )
              // (
              //   <video
              //     style={{ display: "none" }}
              //     loop={true}
              //     autoPlay={true}
              //     muted={true}
              //   >
              //     <source
              //       src={question["Knowledge Piece Image"]}
              //       type={`video/${question["Knowledge Piece Image"].slice(-3)}`}
              //     />
              //   </video>
              // )
            }
            {question["Question Image"].endsWith(".png") ||
            question["Question Image"].endsWith(".jpg") ? (
              <img
                style={{ display: "none" }}
                src={question["Question Image"]}
                alt="Ultrasound Image"
              />
            ) : (
              <div style={{ display: "none" }}></div>
              // <video
              //   style={{ display: "none" }}
              //   loop={true}
              //   autoPlay={true}
              //   muted={true}
              // >
              //   <source
              //     src={question["Question Image"]}
              //     type={`video/${question["Question Image"].slice(-3)}`}
              //   />
              // </video>
            )}
          </>
        ))}
    </>
  );
}

export default App;
